export enum GridRowActionType {
  Dropdown = 'Dropdown',
  IconOverlay = 'IconOverlay',
  Icon = 'Icon'
}
